import styled from "styled-components";
// import Theme from "../../Styles/Themes";
// import config from '../../Config/config.json'

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
`;

export const CheckBoxInput = styled.input`
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #ccc;
    border-radius: 50%;
    margin-right: 10px;
    outline: none;
    cursor: pointer;
    transition: 0.5s;

    &:checked {
        background-color: #33CC99;
    }

`;